<template>
<div class="import-project">
  <el-card class="box-card" shadow="never">
    <div slot="header" class="clearfix"><span>项目列表</span></div>
    <el-form ref="form" class="projectList" :inline="true" :model="form">
      <el-form-item v-for="(item, index) in projectList" :key="index" style="width: 23%;">
        <el-tooltip v-if="item.projectName.length>20" class="ellipsisDisplay" effect="light" :content="item.projectName" placement="top">
          <el-checkbox :label="item.projectName" :value="item.projectId" v-model="item.checked"></el-checkbox>
        </el-tooltip>
        <el-checkbox v-else :label="item.projectName" :value="item.projectId" v-model="item.checked"></el-checkbox>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="saveCheckedProjectList">保存项目</el-button>
  </el-card>
</div>
</template>

<script>
import GROUPAPI from '@/api/group';
export default {
  props: {
    groupId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      form: {},
      projectList: []
    };
  },
  created() {
    if (this.groupId) {
      this.searchProjectList();
    }
  },
  methods: {
    //项目列表
    searchProjectList() {
      let params = {
        groupId: this.groupId
      };
      GROUPAPI.searchProjectList(params).then(res => {
        if (res.data.code == 200) {
          this.projectList = res.data.data;
        }
      });
    },
    //保存项目
    saveCheckedProjectList() {
      let params = {
        groupId: this.groupId,
        projectId: []
      };
      this.projectList.forEach(item => {
        if (item.checked) {
          params.projectId.push(item.projectId);
        }
      });
      GROUPAPI.saveCheckedProjectListV2(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchProjectList();
        }
      });
    }
  }
};
</script>

<style>
.import-project .projectList {
  height: 56vh;
  overflow-y: auto;
}

.projectList .ellipsisDisplay .el-checkbox__label {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/group/importproject.vue